import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

import Colors from '../../../../../constants/Colors';
import BorderlessButton from '../../../../../common/buttons/BorderlessButton';
import { isHoursZero, sumCellHours } from './redistributionHelpers';

export default function RedistributeSidebarRowItem({
  row,
  columnRowId,
  isActive,
  onPress,
}) {
  const isFullyDistributed = isHoursZero(sumCellHours(row?.[columnRowId]));

  const statusIcon = isFullyDistributed ? (
    <CheckCircleOutlined
      style={{
        fontSize: 18,
        color: isActive ? '#FFFFFF' : Colors.GREEN_600,
      }}
    />
  ) : (
    <ExclamationCircleOutlined
      style={{
        fontSize: 18,
        color: isActive ? '#FFFFFF' : '#EF4444',
      }}
    />
  );

  const textClassName = [
    'ttg-redistribute-sidebar-item-text',
    isActive && 'ttg-redistribute-sidebar-item-text-active',
  ].filter(Boolean).join(' ');

  return (
    <BorderlessButton
      iconLeft
      iconNode={(
        <>
          <div className="ttg-redistribute-sidebar-item-leading">
            {statusIcon}
          </div>
          <span className={textClassName}>{row.name}</span>
        </>
      )}
      className={[
        'ttg-redistribute-sidebar-item',
        isActive && 'ttg-redistribute-sidebar-item-active',
      ].filter(Boolean).join(' ')}
      onClick={onPress}
    />
  );
}

RedistributeSidebarRowItem.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  columnRowId: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
};
